/*
 * @Author: zhangke 2211709169@qq.com
 * @Date: 2026-04-16 10:18:20
 * @LastEditors: zhangke 2211709169@qq.com
 * @LastEditTime: 2026-08-26 11:30:22
 * @FilePath: \new_h5_saas_frontend\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import router from "@/router";
import "lib-flexible";
import "@/static/css/reset.css";
import "@/static/font/font.css"; //引入字体文件
import VueClipboard from "vue-clipboard2"; //复制功能
import axios from "axios";
Vue.prototype.$axios = axios;

import {
  Tabbar,
  TabbarItem,
  Button,
  Swipe,
  SwipeItem,
  Picker,
  Popup,
  Area,
  NavBar,
  Form,
  Field,
  SubmitBar,
  Toast,
  List,
  Icon,
  CountDown,
  Dialog,
  Empty,
  Loading,
  Sticky,
  Badge,
  ActionSheet,
  Cell,
  CellGroup,
  Tab,
  Tabs,
  RadioGroup,
  Radio,
  Uploader,
  Search,
} from "vant";

Vue.use(Loading);
Vue.use(Empty);
Vue.use(Dialog);
Vue.use(VueClipboard);
Vue.use(CountDown);
Vue.use(Icon);
Vue.use(List);
Vue.use(Toast);
Vue.use(SubmitBar);
Vue.use(Form);
Vue.use(Field);
Vue.use(NavBar);
Vue.use(Area);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Button);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Sticky);
Vue.use(Badge);
Vue.use(ActionSheet);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Uploader);
Vue.use(Search);

Vue.use(VueRouter);
Toast.setDefaultOptions({ duration: 2000 });
Vue.config.productionTip = false;
new Vue({
  render: (h) => h(App),
  router: router,
}).$mount("#app");
